import { render, staticRenderFns } from "./workorderlist.vue?vue&type=template&id=6a4f9028"
import script from "./workorderlist.vue?vue&type=script&lang=js"
export * from "./workorderlist.vue?vue&type=script&lang=js"
import style0 from "./workorderlist.vue?vue&type=style&index=0&id=6a4f9028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports